import React, { useEffect, useRef,useState } from 'react';
import PortFolioMediaProductionHero from './PortFolioMediaProductionHero/PortFolioMediaProductionHero';
import PortfolioMediaPage from './PortfolioMediaPage/PortfolioMediaPage';
import WithUs from '../../Landing/WithUs/WithUs';
import Footer from '../../../Components/Footer/Footer';
const PortFolioMediaProduction = () => {







  const scrollRef = useRef(null)
  useEffect(()=>{
    scrollRef.current.scrollIntoView()
  }
,[])
  return (
    <div className='overflow-hidden'>
      <div ref={scrollRef}></div>
      <PortFolioMediaProductionHero/>
      <PortfolioMediaPage/>
      <WithUs/>
      <Footer/>
      
    </div>
  );
}

export default PortFolioMediaProduction;
